import * as XLSX from "xlsx";

export const exportarRutaExcel = ({
    ruta,
    ubicaciones = [],
    sensores = [],
    camion
}) => {
    if (!ruta) {
        return;
    }

    // ============================================================
    // 1. RESUMEN
    // ============================================================

    const fechaInicio = ruta.fechaInicio
        ? new Date(ruta.fechaInicio)
        : null;

    const fechaFin = ruta.fechaFin
        ? new Date(ruta.fechaFin)
        : null;

    const duracionMs =
        fechaInicio && fechaFin
            ? fechaFin.getTime() - fechaInicio.getTime()
            : 0;

    const horas = Math.floor(
        duracionMs / (1000 * 60 * 60)
    );

    const minutos = Math.floor(
        (duracionMs % (1000 * 60 * 60)) /
            (1000 * 60)
    );

    const segundos = Math.floor(
        (duracionMs % (1000 * 60)) / 1000
    );

    const resumen = [
        {
            Campo: "Camión",
            Valor: camion.nombre ?? "",
        },
        {
            Campo: "Gateway",
            Valor: ruta.idGateway ?? "",
        },
        {
            Campo: "Estado",
            Valor: ruta.estado ?? "",
        },
        {
            Campo: "Fecha inicio",
            Valor: fechaInicio
                ? fechaInicio.toLocaleString()
                : "",
        },
        {
            Campo: "Fecha fin",
            Valor: fechaFin
                ? fechaFin.toLocaleString()
                : "",
        },
        {
            Campo: "Duración",
            Valor: `${horas}h ${minutos}m ${segundos}s`,
        },
        {
            Campo: "Puntos GPS",
            Valor: ubicaciones.length,
        },
        {
            Campo: "Sensores",
            Valor: sensores.length,
        },
    ];

    // ============================================================
    // 2. CREAR MAPA DE SENSORES POR TIMESTAMP
    // ============================================================

    const sensoresPorTimestamp = {};

    sensores.forEach((sensor) => {
        const nombreSensor =
            sensor.nombre ||
            sensor.deviceID ||
            "Sensor";

        (sensor.datos ?? []).forEach((dato) => {
            if (!dato.timestamp) {
                return;
            }

            if (!sensoresPorTimestamp[dato.timestamp]) {
                sensoresPorTimestamp[dato.timestamp] = {};
            }

            sensoresPorTimestamp[dato.timestamp][
                nombreSensor
            ] = dato.temperatura ?? "";
        });
    });

    // ============================================================
    // 3. OBTENER NOMBRES DE TODOS LOS SENSORES
    // ============================================================

    const nombresSensores = sensores.map(
        (sensor) =>
            sensor.nombre ||
            sensor.deviceID ||
            "Sensor"
    );

    // ============================================================
    // 4. RECORRIDO
    // ============================================================

    const recorrido = ubicaciones.map(
        (punto, index) => ({
            "#": index + 1,

            "Fecha / Hora": punto.timestamp
                ? new Date(
                      punto.timestamp
                  ).toLocaleString()
                : "",

            Latitud: punto.lat ?? "",

            Longitud: punto.lng ?? "",

            "Altitud (m)": punto.altitude ?? "",
        })
    );

    // ============================================================
    // 5. SENSORES
    // ============================================================

    const datosSensores = ubicaciones.map(
        (punto, index) => {
            const fila = {
                "#": index + 1,

                "Fecha / Hora": punto.timestamp
                    ? new Date(
                          punto.timestamp
                      ).toLocaleString()
                    : "",
            };

            nombresSensores.forEach(
                (nombreSensor) => {
                    fila[nombreSensor] =
                        sensoresPorTimestamp[
                            punto.timestamp
                        ]?.[nombreSensor] ?? "";
                }
            );

            return fila;
        }
    );

    // ============================================================
    // 6. DETALLE COMPLETO
    // ============================================================

    const detalleCompleto = ubicaciones.map(
        (punto, index) => {
            const fila = {
                "#": index + 1,

                "Fecha / Hora": punto.timestamp
                    ? new Date(
                          punto.timestamp
                      ).toLocaleString()
                    : "",

                Latitud: punto.lat ?? "",

                Longitud: punto.lng ?? "",

                "Altitud (m)":
                    punto.altitude ?? "",
            };

            nombresSensores.forEach(
                (nombreSensor) => {
                    fila[nombreSensor] =
                        sensoresPorTimestamp[
                            punto.timestamp
                        ]?.[nombreSensor] ?? "";
                }
            );

            return fila;
        }
    );

    // ============================================================
    // 7. CREAR WORKBOOK
    // ============================================================

    const workbook = XLSX.utils.book_new();

    const wsResumen =
        XLSX.utils.json_to_sheet(resumen);

    const wsRecorrido =
        XLSX.utils.json_to_sheet(recorrido);

    const wsSensores =
        XLSX.utils.json_to_sheet(datosSensores);

    const wsDetalle =
        XLSX.utils.json_to_sheet(detalleCompleto);

    // ============================================================
    // 8. ANCHOS DE COLUMNAS
    // ============================================================

    wsResumen["!cols"] = [
        { wch: 25 },
        { wch: 35 },
    ];

    wsRecorrido["!cols"] = [
        { wch: 8 },
        { wch: 22 },
        { wch: 15 },
        { wch: 15 },
        { wch: 15 },
    ];

    wsSensores["!cols"] = [
        { wch: 8 },
        { wch: 22 },
        ...nombresSensores.map(() => ({
            wch: 18,
        })),
    ];

    wsDetalle["!cols"] = [
        { wch: 8 },
        { wch: 22 },
        { wch: 15 },
        { wch: 15 },
        { wch: 15 },
        ...nombresSensores.map(() => ({
            wch: 18,
        })),
    ];

    // ============================================================
    // 9. AGREGAR HOJAS
    // ============================================================

    XLSX.utils.book_append_sheet(
        workbook,
        wsResumen,
        "Resumen"
    );

    XLSX.utils.book_append_sheet(
        workbook,
        wsRecorrido,
        "Recorrido"
    );

    XLSX.utils.book_append_sheet(
        workbook,
        wsSensores,
        "Sensores"
    );

    XLSX.utils.book_append_sheet(
        workbook,
        wsDetalle,
        "Detalle completo"
    );

    // ============================================================
    // 10. DESCARGAR
    // ============================================================

    const fechaArchivo = fechaInicio
        ? fechaInicio
              .toISOString()
              .slice(0, 10)
        : "ruta";

    XLSX.writeFile(
        workbook,
        `detalle_ruta_${fechaArchivo}.xlsx`
    );
};